var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaintPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.007 512.007",
    height: 512,
    viewBox: "0 0 512.007 512.007",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m316 31.496c-9.589-1.053-19.268-1.657-29.121-1.284-76.816 2.769-144.111 48.413-181.479 90.22l-.015 206.616 13.037 1.479c39.302 4.482 66.504 16.978 80.874 37.163 15.879 22.31 11.646 48.472 9.976 55.972-5.563 24.913 9.126 50.275 34.292 55.122 14.224 2.725 28.521 4.072 42.715 4.072 9.996 0 19.894-.906 29.722-2.217 111.117-14.829 196.915-109.357 196-224.438-1.004-122.371-99.862-212.156-196.001-222.705z",
    fill: "#fabe2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 254.202c-1.003-122.372-99.861-212.157-196-222.706v447.144c111.117-14.83 196.915-109.357 196-224.438z",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m339.027 202.991c-17.534-17.563-17.534-46.113-.015-63.662 17.578-17.549 46.113-17.549 63.662 0s17.549 46.099 0 63.647v.015c-17.546 17.518-46.097 17.52-63.647 0z",
    fill: "#00c8c8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m211.483 151.721c-6.385-23.713 7.541-48.603 31.816-55.093 23.906-6.401 48.677 7.837 55.107 31.816 6.443 23.988-7.773 48.671-31.816 55.107-24.097 6.458-48.693-7.839-55.107-31.83z",
    fill: "#474f54"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m158.441 268.411c-23.979-6.431-38.247-31.157-31.817-55.107 6.39-23.901 30.959-38.299 55.093-31.816 24.037 6.426 38.288 31.068 31.831 55.107-6.454 24.114-31.184 38.225-55.107 31.816z",
    fill: "#ff435b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m390.268 330.52c-23.974-6.417-38.286-31.023-31.816-55.107 6.45-24.096 31.184-38.234 55.107-31.816 23.979 6.431 38.247 31.157 31.816 55.107-6.426 24.039-31.127 38.266-55.107 31.816z",
    fill: "#99341f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m91 .004c-37.192 0-45 139.677-45 256 0 5.228.066 10.025.106 15l31.768 15h13.126 21.249l23.652-15c.037-4.977.099-9.688.099-15 0-116.324-7.808-256-45-256z",
    fill: "#b35324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.901 271.004c.037-4.977.099-9.688.099-15 0-116.323-7.808-256-45-256v286h21.249z",
    fill: "#99341f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91 271.004h-44.894c.536 66.334 4.338 109.911 4.552 113.921h40.342 40.342c.394-7.324 4.063-44.714 4.559-113.921z",
    fill: "#fff7e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.901 271.004h-44.901v113.921h40.342c.393-7.325 4.063-44.715 4.559-113.921z",
    fill: "#ffccb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91 361.004c-33.091 0-60 26.909-60 60v30c0 16.538-14.462 31-31 31v30h61c10.571 0 20.57-2.166 30-5.528 34.845-12.424 60-46.414 60-85.472 0-33.091-26.909-60-60-60z",
    fill: "#474f54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151 421.004c0-33.091-26.909-60-60-60v145.472c34.845-12.424 60-46.414 60-85.472z",
    fill: "#32393f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 376.004,
    fill: "#fff7e6",
    r: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361 376.004c0-24.853-20.147-45-45-45v90c24.853 0 45-20.147 45-45z",
    fill: "#ffe6cc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintPalette);
export default __webpack_public_path__ + "static/media/paint-palette.6e40bf9891178d8dca9662e7a0d3492b.svg";
export { ForwardRef as ReactComponent };